import $ from 'jquery'; // gridder requires jQuery
import './_gridder.js';

jQuery(document).ready(function ($) {
	/**
	 * Gridder
	 */
	var offset = 150;
	if ($(window).width() >= 1024) {
		offset = 400;
	} else if ($(window).width() >= 758) {
		offset = 300;
	} else {
		offset = 150;
	}

	// First, figure out the right height offset.
	jQuery('.gridder').gridderExpander({
		scroll: true,
		scrollOffset: offset,
		scrollTo: 'panel', // panel or listitem
		animationSpeed: 400,
		animationEasing: 'easeInOutExpo',
		showNav: true,
		onStart: function () {},
		onContent: function () {},
	});

	// Simplified, does NOT close others
	jQuery('.directory .toggleContent').click(function (e) {
		var $this = $(this);
		$this.parent('.directoryItem').toggleClass('open');
	});

	jQuery('.peopleFilter').change(function () {
		var filters = $.map($('.peopleFilter').toArray(), function (e) {
			return $(e).val();
		}).join('.');
		$('.directoryItem').hide();
		$('.directoryItem.' + filters).show();
	});
});
